import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { sbaAxios } from "../../utils/sbaAxios";
import { getPortfolioTransaction } from "../../../config/apiConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { getPortFolioDetailAction, getPortFolioListAction } from "../../actions/portfolioAction";
import { useDispatch, useSelector } from "react-redux";
import { CurrencyFormat } from "../../utils/currencyFormattter";
import { SBAComboBox } from "../../UiComponents/SBADropDown";
import download from "../../../Images/download.svg";
import { DateRangePicker } from "rsuite";
import { useRef } from "react";
import { exportToExcelUsingRef } from "../../utils/excelExporter";
import { getCustomSettings,getUserPageAccess,deleteTransaction } from "../../../config/apiConfig";
import { SBGrid } from "../../UiComponents/SBAAGgrid";
import { HoverList } from "./transactionMenus";
import { ToastContainer } from "react-toastify";
import { Modal } from "react-bootstrap";
import { SBNotify } from "../../utils/sbNotify";
import { SBDateRangePicker } from "../../UiComponents/SBDateRangePicker";

export const PortfolioTransaction = () => {
    const param = useParams();
    const dispatch = useDispatch();
    
    const Gstate = useSelector(state => state);
    const Stateportfolio = Gstate.portfolio.portfolio;
    const portfolioList = Gstate.portfolio.portfolioList;
    const portfolioId = parseInt(param.PortfolioId);
   
    const Level = [
        { BreadCrumb: "Portfolio >", Routes: `/${UrlPath.PortfolioList}` },
        { BreadCrumb: `${Stateportfolio?.PortfolioName} >`, Routes: `/${UrlPath.PortfolioDetails}${portfolioId}` },
        { BreadCrumb: "Transactions", Routes: `/${UrlPath.portfolioTransaction}${portfolioId}` }
       
    ];

    useEffect(() => {
        document.title = 'Portfolio Transactions';
        dispatch(getPortFolioListAction(null));
    }, []);
    useEffect(() => {
        dispatch(getPortFolioDetailAction(portfolioId))
    }, [portfolioId]);
   
    return <> <TopBar label={"Portfolio Transactions"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="container-fluid">
                <div>
                    <PortfolioTransactionGrid />
                </div>
            </div>
        </div>
    </>
};

export const PortfolioTransactionGrid = () => {
    const param = useParams();
    const history = useNavigate();
    const oneMonthAgo = new Date();
    const oneMonthAfter = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  oneMonthAfter.setMonth(oneMonthAfter.getMonth() + 1);
  const portfolioTransFilters = JSON.parse(localStorage.getItem("PortfolioTransactionFilter"));
  const startDate = portfolioTransFilters?.startDate ? new Date(portfolioTransFilters?.startDate) : oneMonthAgo;
  const endDate = portfolioTransFilters?.endDate ? new Date(portfolioTransFilters?.endDate) : oneMonthAfter;
  const [selectedFromDate, setSelectedFromDate] = useState(startDate);
  const [selectedToDate, setSelectedToDate] = useState(endDate);

    const [gridData, setGridData] = useState([]);
    const [transactionDateRange, setTransactionDateRange] = useState([startDate, endDate]);
    const [render,setRender]=useState(false);
    const Gstate = useSelector(state => state);
    const Stateportfolio = Gstate.portfolio.portfolio;
    const portfolioList = Gstate.portfolio.portfolioList;
    const transactionRef=useRef();
    const [colDef, setColDef] = useState();
    const [appliedFilter, setAppliedFilter] = useState(null);
    const portfolioId = parseInt(param.PortfolioId);
    const [transactionEditAccess,setTransactionEditAccess]=useState(false);
    const [transactionAddAccess, setTransactionAddAccess] = useState(false);
    const [transactionDeleteAccess, setTransactionDeleteAccess] = useState(false);
    const isEditable = Gstate.authorizationData.isEditable;
    const [isHovered, setIsHovered] = useState(false);
    const [showdeleteModal,setShowdeleteModal]=useState(false);
    const [transactionId,setTransactionId]=useState(0);
    const location=useLocation();
    useEffect(() => {
        getGridData(portfolioId, selectedFromDate.toISOString(), selectedToDate.toISOString());
        getTransactionAccess();
        fetchGridData();
    }, [portfolioId,render,transactionDeleteAccess]);
    const getGridData = async (portfolioId,startDate,endDate) => {
        try {
         
          return await sbaAxios({
            url: `${getPortfolioTransaction}${portfolioId},${startDate},${endDate}`}).then(res => {
                setGridData(res);
            })
        }
        catch {
            setGridData([]);
        }
    };
    const deleteModalpopup=(Id)=>
    {
        setTransactionId(Id)
        setShowdeleteModal(true);

    }
    // Date Range 
    const handleDateChange = (e) => {
       
        if (e) {

            const newStartDate = e.value.start !== null ? e.value.start : selectedFromDate;
            const newEndDate = e.value.end !== null ? e.value.end : selectedToDate;
            setTransactionDateRange([newStartDate, newEndDate]);
            setSelectedFromDate(newStartDate);
            setSelectedToDate(newEndDate);
        }
    };

     // Delete Transaction
  const deleteTransactionById = async () => {
    
    try {
      const response = await sbaAxios({
        url: `${deleteTransaction}${transactionId}`,
        method: 'get',

      });
      if(response)
      {
        SBNotify({Msg:"Selected Transaction Deleted Successfully"});
      }
      else {
        SBNotify({Msg:"Transaction has Child Records", type:'error'});
      }
      setShowdeleteModal(false);
    
        getGridData(portfolioId, selectedFromDate.toISOString(), selectedToDate.toISOString());
     
    }
    catch (error) {
      console.error("Error Deleting task view columns:", error.message);
      SBNotify({
        Msg: error.message,
        type: "error",
      });

    }

  };
    const navigateToTransType=(TransData)=>{
        const transType=TransData.TransType.replace(/\s/g, '');
        const TransId=TransData?.TransId || 0;
        if(transType==="RedeemtoCash")
        history(`/${UrlPath.portfolioTransaction}${'Redemption'}/${TransId}/${param.PortfolioId}/3`);
        else
        {
        if(transType==="DistributiontoHoldbacks")
        history(`/${UrlPath.portfolioTransaction}${'Distribution'}/${TransId}/${param.PortfolioId}/3`);
        else
        history(`/${UrlPath.portfolioTransaction}${transType}/${TransId}/${param.PortfolioId}/3`);
     
        }

    }
    const ActionColRender=(e)=>{
      
        return <>
            <i className="fas fa-edit" style={{ color: true ? "#47A547" :"grey", margin: "0 8px", cursor: "pointer" }} onClick={()=>{navigateToTransType(e.data)}}></i>  
            <i className={"fa fa-trash"} style={{ color: (transactionDeleteAccess && !e.data.IsLocked) === true ? "#DF001B" : "#808080", margin: "0 8px", cursor: "pointer" }} onClick={()=>{(transactionDeleteAccess && !e.data.IsLocked) &&  deleteModalpopup(e.data.TransId)}}></i>
        </>
  
    }
    const getCustomSetting = async () => {
        try {
            const response = await sbaAxios({ url: `${getCustomSettings}${1019}` });
            if (response) {

                const apiColDef = JSON.parse(response.CustomSettingsValue);
                const apiFilters = JSON.parse(response.CustomFilterValue);
                const formattedDef = apiColDef.map(item => ({
                    ...item,
                    "field": item.colId,
                    floatingFilter:item.colId!=='action',
                    valueGetter: (item.colId === "TransDate" || item.colId === "ModifiedDate") ?(e)=>{ return getDateString(e,item.colId)} : (item.colId === "LocalAmount" || item.colId === "TransAmount") ?  (e)=>{return currencyValueFormatter(e,item.colId)}: null,
                    cellRenderer: (item.colId === "LocalAmount" || item.colId === "TransAmount") ? (e)=>{return FormatCurrencyGrid(e,item.colId)} : item.colId==='action' ? ActionColRender : null,
                    "headerName": item.colId === "PortfolioName" ? "Portfolio" : item.colId === "AssetName" ? "Asset" : item.colId === "ShareClassName" ? "Share Class" : item.colId === "AssetLotName" ? "Lot" : item.colId === "TransDate" ? "Date" : item.colId === "TransType" ? "Type" : item.colId === "TransAmount" ? "Amount" : null,
                    "tooltipField": item.colId === "PortfolioName" ? "PortfolioName" : item.colId === "AssetName" ? "AssetName" : item.colId === "TransType" ? "TransType" : null,
                    cellStyle: { textAlign: (item.colId === "Shares" || item.colId === "NAV" || item.colId === "LocalAmount" || item.colId === "TransAmount") ? "right" : "left" } 
            }));
                return { columns: [...formattedDef], filters: apiFilters };
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    };

    const fetchGridData = async () => {
        try {
            const customSettings = await getCustomSetting();
            setColDef(customSettings.columns);
            setAppliedFilter(customSettings.filters);
        } catch (error) {
            console.error("Error fetching custom settings:", error);
        }
    };
    const defaultColDef = {
        sortable: false,
        floatingFilter: true,
        minWidth: 100,
        flex: 1
    };
    const portfolioDropDownChange = (e) => {
        if (e.value) {
            const pID = e.value.PortfolioId;
            history(`/${UrlPath.portfolioTransaction}${pID}`);
        }
    }
    const currencyValueFormatter = (params,fieldName) => {
      const num = params.data[fieldName];
      if (num) {
        const formattedValue = `$${(num).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2})}`
        return formattedValue;
      } else {
        return '';
      }
    };


    const getTransactionAccess = async  () => {
        try {
         //  const transactionEditAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=TransactionEditAccess` });
      const transactionAddAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=TransactionAddAccess` });
      const transactionDeleteAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=TransactionDeleteAccess` });
      const [
       // transactionEditAccessResponse,
        transactionAddAccessResponse,
        transactionDeleteAccessResponse,
       
      ] = await Promise.all([
        //transactionEditAccessPromise,
        transactionAddAccessPromise,
        transactionDeleteAccessPromise
      ]);
     // setTransactionEditAccess(transactionEditAccessResponse);
      setTransactionAddAccess(transactionAddAccessResponse);
      setTransactionDeleteAccess(transactionDeleteAccessResponse);
         
        } catch (error) {
          console.error("An error occurred:", error);
          
        }
      };
      
  const handleListMouseEnter = () => {
    setIsHovered(true);
  };

  const handleListMouseLeave = () => {
    setIsHovered(false);
  };
  const loadTransactionList=()=>{
    const portfolioTransactionFilter={
      startDate: selectedFromDate.toISOString(),
      endDate:selectedToDate.toISOString()
    }
    localStorage.setItem('PortfolioTransactionFilter',JSON.stringify(portfolioTransactionFilter));
    setRender(value=>!value);
  }
    return <>
        <div className="row">
            <div className="col-md-3">
                <label className="label">Select Portfolio</label>
                <SBAComboBox data={portfolioList} onChange={portfolioDropDownChange} textField={"PortfolioName"} valueField={"PortfolioId"} value={Stateportfolio} />
            </div>
            <div className="col-md-3">
                <label className="label">Select Date Range</label>

                <SBDateRangePicker
                    value={{ start: transactionDateRange[0], end: transactionDateRange[1] }}
                    onChange={(e) => { handleDateChange(e) }}

                />
                {/*<DateRangePicker*/}
                {/*    className="SbaDateRage"*/}
                {/*    placeholder="Select Date Range"*/}
                {/*    value={transactionDateRange}*/}
                {/*    format="MM/dd/yyyy"*/}
                {/*    block*/}
                {/*    character=" - "*/}
                {/*    onChange={(e) => { setTransactionDateRange(e) }}*/}
                {/*    onKeyUp={(e)=>{if(e.code==='Enter'){*/}
                {/*        setRender(value=>!value);*/}
                {/*    }}}*/}
                {/*/>*/}
            </div>
            <div className="col-md-2 row-items">
                <button class="p-sm-btn mx-1" disabled={false} onClick={() => { loadTransactionList() }}>Go</button>
            </div>
            <div className="col-md-4 row-items justify-content-end">
              
                <div>
                        <button
                            type="submit"
                            className="p-sm-btn mx-1"
                            disabled={!transactionAddAccess}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >
                            <i className="fa-solid fa-plus" />
                            Add
                        </button>
                        <HoverList
                            isHovered={isHovered}
                            handleListMouseEnter={handleListMouseEnter}
                            handleListMouseLeave={handleListMouseLeave}
                        />
                
                    </div>
                <button class="p-sm-btn mx-1" disabled={false} onClick={() => { exportToExcelUsingRef(transactionRef,'Portfolio Transaction') }}><img src={download} alt="DL" />Export</button>
            </div>
        </div>
        <div className="ag-theme-alpine m-1">

            <SBGrid ref={transactionRef} column={colDef} row={gridData} filters={appliedFilter} componentID={1019} gridStyle={{ width: '100%', height: '80vh' }}></SBGrid>      
        </div>
          {/* View Delete Modal ----- */}
      <Modal show={showdeleteModal}>
        <Modal.Header
          closeButton
          onClick={() => {
            setShowdeleteModal(false);
          }}
        >
          <Modal.Title>
            Delete Transaction
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Do you want delete this Transaction?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="s-sm-btn mx-1"
            onClick={() => {
                setShowdeleteModal(false);
            }}
          >
            Cancel
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={deleteTransactionById}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
        <ToastContainer/>
    </>
};
const getDateString = (params,fieldName) => {
  const value = params.data[fieldName];
    return moment(value).format('MM-DD-YYYY');
};
const FormatCurrencyGrid = (params,fieldName) => {
  var num = params.data[fieldName];
  if (num !== undefined) {
    const isNegative = num < 0;
  
    const formattedValue = isNegative
      ? `($${Math.abs(num).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })})`
      : `$${num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    const style = isNegative ? { color: 'red' } : null;

    return <span style={style}>{formattedValue}</span>;
  } else {
    return num;
  }
};